<template>
  <div>
    <!-- SET PAYMENT START -->
    <CCol xs="12" md="12" lg="6" class="col-centered update-column">
      <h4 class="card-subtitle">Learning Payment</h4>
      <br>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <CRow>
        <CCol md="4">
          <strong>Description</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ desc }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Parent Name</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ pname }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Student Name</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ sname }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Invoice</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ invoice }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Discount</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ discount }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Additional Payment</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ addpmt }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Final Payment</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ finpmt }} </span>
        </CCol>
      </CRow>
      <br>
      <hr>
      <br>
      <CRow>
        <CCol md="4">
          <strong>Payment Amount</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ pmtamt }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Balance Exceed</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ balexceed }} </span>
        </CCol>
      </CRow>
      <br>
      <hr>
      <input type="submit" value="View Receipt" class="btn btn-success" /> &nbsp;
      <input type="submit" value="Change Payment Amount" class="btn btn-primary" />
      <br>
    </CCol>
    <!-- SET PAYMENT END -->

    <br>

    <!-- ADD ADDITIONAL PAYMENT START -->
    <CCol xs="12" md="12" lg="12" class="col-centered update-column">
      <h4 class="card-subtitle">Add additional payment for student</h4>
      <br>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <CCol md="12">
        <div>
          <label><strong>Student: </strong> </label>
        </div>
        <br>
        <h6 class="card-subtitle">List of <code>additional payment</code></h6>
        <br>
        <div class="table-responsive">
          <table class="table">
          <thead>
            <tr>
              <th>Payment Info</th>
              <th>Payment Fee (RM)</th>
              <th>#</th>
            </tr>
          </thead>
          <tbody style="background-color:white">
            <tr>
              <td>Recorrect invoice</td>
              <td>29</td>
              <td>
                <input type="submit" value="Remove" class="btn btn-danger pull-right">
              </td>
            </tr>                                             
            <tr>
              <td>
                <input type="text" class="form-control">
              </td>
              <td>
                <input type="number" value="0" step="any" class="form-control">
              </td>
              <td>
                <input type="submit" value="Add" class="btn btn-primary">
              </td>
            </tr>
          </tbody>
          </table>
        </div>
        <br>
      </CCol>
    </CCol>
    <!-- ADD ADDITIONAL PAYMENT END -->

    <br>   
    
    <!-- DELETE PAYMENT START -->
    <CCol xs="12" md="12" lg="6" class="col-centered update-column">
      <h4 class="card-subtitle">Delete Learning Payment</h4>
      <br>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <CRow>
        <CCol md="4">
          <strong>Description</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ desc }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Parent Name</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ pname }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Student Name</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ sname }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Invoice</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ invoice }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Discount</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ discount }} </span>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="4">
          <strong>Final Payment</strong>
        </CCol>
        <CCol md="8">
          <span>: {{ finpmtdel }} </span>
        </CCol>
      </CRow>
      <br>
      <hr>
      {{ text }} 
      <br>
      <input type="submit" value="Delete" class="btn btn-danger" />
      <br>
    </CCol>
    <!-- DELETE PAYMENT END -->
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import $ from "jquery";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
import jQuery from "jquery";

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      desc: "June 2018",
      pname: "office.akim@advancedcellnet.com", 
      sname: "Super Cold And Hot Trial By Son Of Fuhrer The Great",
      invoice: "RM 1",
      discount: "RM 0",
      addpmt: "RM 29",
      finpmt: "RM 30",
      pmtamt: "RM 30",
      balexceed: "RM 0",
      finpmtdel: "RM 1",
      text: "Are you sure you want to delete this payment data?",
    }
  },
}
</script>

